import { StatusBadge, type StatusTone } from "@/components/status-badge";
import type { BulkStatementRunItem } from "@/lib/statement-runs";

export type BulkRunItemStatus = BulkStatementRunItem["status"];

const tone: Record<BulkRunItemStatus, StatusTone> = {
  Pending:   "neutral",
  Generated: "info",
  Delivered: "success",
  Failed:    "danger",
  Skipped:   "muted",
};

const label: Record<BulkRunItemStatus, string> = {
  Pending:   "Pending",
  Generated: "Generated",
  Delivered: "Delivered",
  Failed:    "Failed",
  Skipped:   "Skipped",
};

export interface BulkRunItemStatusBadgeProps {
  status: BulkRunItemStatus;
}

export function BulkRunItemStatusBadge({ status }: BulkRunItemStatusBadgeProps) {
  return <StatusBadge tone={tone[status]}>{label[status]}</StatusBadge>;
}
